module.exports = __webpack_public_path__ + "static/media/buildingConstruction24.f0de60f1.jpg";